import PropTypes from "prop-types";
import React, { Component } from "react";
import ImageCarousel from "../components/imageCarousel";

export default class InstagramFeed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      instaUser: {},
      feed: [],
      selectedID: "",
      previousMedia: "",
      imageClass: "",
      playVideo: false,
    };
  }

  componentDidMount() {
    var igf =
      "id,caption,media_type,media_url,permalink,thumbnail_url,timestamp,username";
    var igurl = "https://graph.instagram.com/me/media?fields=" + igf + "&";
    this.connectInstagram(this.props.tagSearch, igurl).then((data) => {
      this.setState(
        { feed: data.data, selectedID: data.data[0].id },
        function () {
          setTimeout(() => {
            this.checkPostChildren(data.data[0].id);
          }, 500);
        }
      );
    });
  }

  componentWillUnmount() {}

  connectInstagram(tag, igurl) {
    var accessToken =
      "IGQVJWT2w5OUJ5MEVpVjROek51UXhDeFpQTWNTZAWdKSEJMaXhncXk2YlpQcDh1bGY5NnJ6eVk3OEZAuR3hvVlVueUVyZAVBjeWpuTlJzb1p1VkZATYmU3aVhNendFYkpsVzVlZAjhhRGxR";

    const fetchIG = fetch(igurl + "access_token=" + accessToken);

    var p = new Promise((resolve, reject) => {
      fetchIG
        .then((resp) => resp.json())
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return p;
  }

  checkPostChildren(id) {
    let { feed } = this.state;
    let index = feed.findIndex((obj) => obj.id === id);
    var igurl = "https://graph.instagram.com/" + id + "/children?";

    this.connectInstagram("", igurl)
      .then((d) => {
        const getChildrenMedia = async (ch) =>
          Promise.all(ch.map((c) => this.getChildData(c)));

        getChildrenMedia(d.data).then((e) => {
          feed[index].children = e;

          this.setState({ feed });
        });
      })
      .catch((err) => {
        reject(err);
      });
  }

  getChildData(ch) {
    var p = new Promise((resolve, reject) => {
      var igurl =
        "https://graph.instagram.com/" +
        ch.id +
        "?fields=id,media_type,media_url,username,timestamp&";

      this.connectInstagram("", igurl)
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });

    return p;
  }

  selectFocusImage = (id) => {
    let { feed } = this.state;
    let focused = feed.filter((obj) => obj.id === id)[0];

    if (
      focused.media_type == "CAROUSEL_ALBUM" &&
      !focused.hasOwnProperty("children")
    ) {
      this.checkPostChildren(id);
    }

    this.setState({ selectedID: id, imageClass: "fadeOut" }, function () {
      setTimeout(() => {
        this.setState({
          imageClass: "",
          previousMedia: focused.media_url,
          playVideo: false,
        });
      }, 500);
    });
  };
  // "https://scontent.cdninstagram.com/v/t51.2885-15/84356667_178950773390952_1534874630215140172_n.jpg?_nc_cat=111&_nc_sid=8ae9d6&_nc_ohc=GLQ5haWu8XEAX_S8QcU&_nc_ht=scontent.cdninstagram.com&oh=d20c2bbcbe707e28f4a90dd7491d615a&oe=5F071333"

  playVideo = () => {
    let { playVideo } = this.state;
    this.refs.video.paused ? this.refs.video.play() : this.refs.video.pause();
    this.setState({ playVideo: !playVideo });
  };

  render() {
    let { feed, selectedID, previousMedia, imageClass, playVideo } = this.state;
    let focused = feed.filter((obj) => obj.id === selectedID)[0];

    let instagramURL =
      "https://www.instagram.com/accounts/login/?next=%2Fqwixskinz%2F&source=follow";

    return (
      <div className="qs-b" ref="instagram">
        <div className="container block-wrap behind-trees instagram-wrap">
          {typeof focused !== "undefined" ? (
            <div className="featured-wrap d-flex flex-wrap justify-content-center align-items-stretch">
              <div
                className="col-8 col-md-6 col-lg-4 media"
                style={{
                  backgroundImage: "url(" + focused.media_url + ")",
                }}
              >
                {focused.hasOwnProperty("children") &&
                focused.media_type === "CAROUSEL_ALBUM" ? (
                  <div key={focused.id} id={focused.id}>
                    <ImageCarousel
                      className="ig-media"
                      images={focused.children.map((c) => c.media_url)}
                    />
                  </div>
                ) : focused.media_type === "VIDEO" ? (
                  <div className="video-wrap">
                    <video ref="video" loop className={` back ${imageClass}`}>
                      <source src={focused.media_url} />
                      Video not supported.
                    </video>
                    <div
                      id="video-controls"
                      className={`video-state-${playVideo ? "play" : "pause"}`}
                    >
                      <button type="button" onClick={() => this.playVideo()}>
                        <div className="play icon">
                          <object
                            data="../images/fa/regular/play-circle.svg"
                            type="image/svg+xml"
                            className="fa scrollArrow"
                            width="50"
                            height="50"
                          />
                        </div>
                        <div className="pause icon">
                          <object
                            data="../images/fa/regular/stop-circle.svg"
                            type="image/svg+xml"
                            className="fa scrollArrow"
                            width="50"
                            height="50"
                          />
                        </div>
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="img_vert_wrap">
                    <div className="vert_holder"> </div>
                    <img src={focused.media_url} />
                  </div>
                )}
              </div>
              {/* comments */}
              <div className="col-8 col-md-6 col-lg-4 comments-wrap">
                <div className="profile">
                  <div className="avatar">
                    <img src="../images/logo/ig_profile.jpg" />
                  </div>
                  <div className="avatar-extended">
                    <a
                      className="btn btn-sm btn-insta"
                      target="_blank"
                      href="https://www.instagram.com/qwixskinz/"
                    >
                      <object
                        data="../images/fa/brand/instagram.svg"
                        type="image/svg+xml"
                        width="14"
                      />
                      Follow us on Instagram
                    </a>
                  </div>
                </div>
                <div className="info-wrap">
                  <span className="caption">{focused.caption}</span>
                  <a
                    href={focused.permalink}
                    target="_blank"
                    className="insta-external-link"
                  >
                    View post on Instagram
                  </a>
                  <div className="bottom">
                    <span className="posted-location">
                      <div>
                        {focused.media_type == "VIDEO" ? (
                          <object
                            data="../images/fa/light/video.svg"
                            type="image/svg+xml"
                          />
                        ) : focused.media_type == "CAROUSEL_ALBUM" ? (
                          <object
                            data="../images/fa/light/images.svg"
                            type="image/svg+xml"
                          />
                        ) : (
                          <object
                            data="../images/fa/light/image.svg"
                            type="image/svg+xml"
                          />
                        )}
                      </div>
                    </span>
                    <span className="posted-date">
                      <object
                        data="../images/fa/light/calendar-alt.svg"
                        type="image/svg+xml"
                      />
                      {new Date(focused.timestamp).toLocaleDateString("en-US", {
                        weekday: "short",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="loader">
              <a href="https://www.instagram.com/qwixskinz/" target="_blank">
                Loading
                <br />
                Feed
              </a>
            </div>
          )}

          <div className="instagram-thumbs d-flex flex-row flex-nowrap">
            {feed.map((obj) => {
              var ml = obj.media_url;
              var typeicon = "images.svg";
              if (obj.media_type === "VIDEO") {
                ml = obj.thumbnail_url;
              }
              return (
                <div key={obj.id} className="col thumb">
                  <button
                    type="button"
                    onClick={() => this.selectFocusImage(obj.id)}
                    className={`
                    thumbbtn  ${obj.id === selectedID ? "active" : ""}
                  `}
                  >
                    <img
                      src={ml}
                      className={`
                              thumbimg  ${obj.id === selectedID ? "active" : ""}
                            `}
                    />
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
